import React, { useMemo } from 'react';
import fp from 'lodash/fp';
import { castDate } from '@factorin/util';
import bytes from 'bytes';

import { FactorinViewColumn } from 'Modules/business/fapp';
import { Box, Tooltip, Typography } from 'Modules/ui3';

import { Descision, DescisionFile } from '../../api';


type DescisionsCells = FactorinViewColumn<Descision>['Cell'];


export const formatDate = (date: string | Date) => {
    const dateObject = castDate(date);
    if (dateObject)
        return `${dateObject.toLocaleString('ru', { day: '2-digit', month: '2-digit' })}.${dateObject.getFullYear()}`;
    return null;
};

export const DateCell: DescisionsCells = ({ data, column: { field } }) => (
    <Box>
        <Typography component='div' color='#16161A' fontSize='20px' lineHeight='1.5'>
            {formatDate(fp.get(field, data))}
        </Typography>
    </Box>
);

export const StringCell: DescisionsCells = ({ data, column: { field } }) => (
    <Box>
        <Tooltip
            text={fp.get(field, data)}
            textProps={{
                variant: 'regularBody2',
            }}
        >
            <Typography
                component='div'
                color='#16161A'
                fontSize='20px'
                lineHeight='1.5'
                overflow='hidden'
                textOverflow='ellipsis'
            >
                {fp.get(field, data)}
            </Typography>
        </Tooltip>
    </Box>
);

export const FilesCell: DescisionsCells = ({ data, column: { field } }) => {
    const docs = useMemo(() => fp.pipe(
        fp.get(field),
        fp.filter({ Kind: 'IssueDecision' }),
    )(data), [field, data]) as DescisionFile[];
    return (
        <Box>
            {docs.map(({ Data, KindName, MediaType, Size }, index) => (
                <Box key={`doc_${index}`}>
                    <Typography
                        component='a'
                        href={`data:application/pdf;base64,${Data}`}
                        download={`${KindName}${MediaType}`}
                        fontSize='20px'
                        lineHeight='1.5'
                        color='#5373F2'
                        title={`${KindName}${MediaType}`}
                    >
                        <Typography
                            overflow='hidden'
                            textOverflow='ellipsis'
                            fontSize='inherit'
                            lineHeight='inherit'
                        >
                            {KindName}
                        </Typography>
                        {MediaType}
                    </Typography>
                    <Typography
                        component='span'
                        fontSize='20px'
                        lineHeight='1.5'
                        color='grayscale.shade90'
                    >
                        {' '}{bytes(Size, { unitSeparator: ' ' })}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

